import React from 'react';

const TableOfContents = ({ sections }) => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div
      className="rounded-2xl p-6 sticky top-24"
      style={{ background: '#F8F9FC', border: '1px solid rgba(13,33,55,0.08)' }}
    >
      <h3 className="text-sm font-semibold uppercase tracking-wider mb-4" style={{ color: '#E8732A' }}>
        Contents
      </h3>
      <ul className="space-y-2">
        {sections?.map((section, i) => (
          <li key={i}>
            <button
              onClick={() => scrollTo(section?.id)}
              className="text-sm text-left w-full transition-colors hover:text-orange-500"
              style={{ color: '#6B7280' }}
            >
              {i + 1}. {section?.title}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TableOfContents;
